<template>
  <div class="anim__wrapper">
    <div class="socials">
      <a 
        :key="social.name"
        :href="social.url"
        target="_blank"
        rel="noopener"
        v-for="social in socials"
        data-mouse
        data-mouse-attractionstate="active"
        data-mouse-attractionval="20"
        data-mouse-magnetism="5"
        data-hover-type="zoom"
      >
        <img 
          :src="`/static/vector/${social.name}.svg`"
          :alt="social.alt"
        />
      </a>
    </div>
  </div>
</template>

<script>
import Paragraph from '@/components/typo/Paragraph';

export default {
  name: 'Social',

  components: {
    Paragraph,
  },

  data() {
    return {
      socials: [
        {
          name: 'ig',
          alt: 'Instagram link',
          url: 'https://www.instagram.com/bersiserlini_franciacorta/',
        },
        {
          name: 'fb',
          alt: 'Facebook link',
          url: 'https://www.facebook.com/bersiserlini.franciacorta/',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../application';

.socials {
  @extend %flex;

  img {
    width: 22px;
    height: 22px;
  }

  a {
    display: inline-block;
    padding: 20px 2px 20px 20px;

    &:nth-child(even) {
      padding: 20px 20px 20px 2px;
    }
  }

  a + a {
    margin: 0 0 0 $margin;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/Social.vue